import { Injectable } from "@angular/core";
import { Resolve, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import {VoucherTemplateGroupList} from "../../models/voucherTemplateGroupList";
import {VoucherTemplateGroupService} from "../../services/voucherTemplateGroup.service";

@Injectable()
export class VoucherGroupsResolve implements Resolve<VoucherTemplateGroupList> {
    constructor(private groupService: VoucherTemplateGroupService) {}

    resolve(route: ActivatedRouteSnapshot): Observable<VoucherTemplateGroupList> {
        return this.groupService.getAll(0, 100);
    }
}
